import PazienteEventi from "../";

const routes = [{ name: "PazienteEventiList", path: "/pazienteeventi", component: PazienteEventi.PazienteEventiList, meta: { title: "Paziente Eventi" } }];

export default routes;
